import { render, staticRenderFns } from "./UpDownTag.vue?vue&type=template&id=5e4671f8"
import script from "./UpDownTag.vue?vue&type=script&lang=js"
export * from "./UpDownTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports